<template>
    <billing-panel class="billing-metric">
        <billing-icon-tile :icon="icon" :tone="tone" />
        <div class="billing-metric__copy">
            <div class="billing-metric__label">{{ label }}</div>
            <div class="billing-metric__value">{{ value }}</div>
            <div v-if="caption" class="billing-metric__caption">
                {{ caption }}
            </div>
        </div>
    </billing-panel>
</template>

<script>
import BillingIconTile from './BillingIconTile.vue';
import BillingPanel from './BillingPanel.vue';

export default {
    name: 'BillingMetricCard',
    components: {
        BillingIconTile,
        BillingPanel,
    },
    props: {
        icon: {
            type: String,
            default: '$vuetify.icons.info',
        },
        tone: {
            type: String,
            default: 'blue',
        },
        label: {
            type: String,
            default: '',
        },
        value: {
            type: [String, Number],
            default: '',
        },
        caption: {
            type: String,
            default: '',
        },
    },
};
</script>

<style scoped>
.billing-metric {
    align-items: center;
    display: flex;
    gap: 18px;
    min-height: 104px;
    padding: 18px 22px;
}

.billing-metric__copy {
    min-width: 0;
}

.billing-metric__label {
    color: var(--billing-muted);
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.08em;
    text-transform: uppercase;
}

.billing-metric__value {
    color: var(--billing-text);
    font-size: 28px;
    font-weight: 800;
    line-height: 1.15;
    margin-top: 6px;
}

.billing-metric__caption {
    color: var(--billing-muted);
    font-size: 13px;
    margin-top: 4px;
}
</style>
